import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetDoctorDocumentDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/DoctorDocument/GetDetail?` + params, null);

export const GetDoctorDocumentList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/DoctorDocument/GetList?` + params, null);

export const CreateDoctorDocument = (data: any) =>
  POST_ENC(`${BASE_URL}/api/DoctorDocument/Create`, data, true);

export const UpdateDoctorDocument = (data: any) =>
  POST_ENC(`${BASE_URL}/api/DoctorDocument/Update`, data, true);

export const DeleteDoctorDocument = (data: any) =>
  POST_ENC(`${BASE_URL}/api/DoctorDocument/Delete`, data);
